// extracted by mini-css-extract-plugin
export default {"error":"CustomInputPromoCode_error__v8jB9","codeBtn":"CustomInputPromoCode_codeBtn__UAwQc"};